<!--
    描述：专家需求
    日期：2022/9/19
    创建人：李家宝
-->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="专 家 需 求 " name="1">
        <!--规避单位-->
        <div class="zjxq_box">
          <div class="box_text">规避单位</div>
          <el-table
            class="mt10"
            highlight-current-row
            border
            ref="table"
            :data="evadeUnitsArr"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="sname"
              min-width="200"
              label="单位名称"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </div>
        <!--规避专家-->
        <div class="zjxq_box">
          <div class="box_text">规避专家</div>
          <el-table
            class="mt10"
            highlight-current-row
            row-key="id"
            border
            ref="table"
            :data="evadeExpertsArr"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="sname"
              align="center"
              label="专家姓名"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="手机号"
              show-overflow-tooltip
            >
            </el-table-column>
            <!--<el-table-column-->
            <!--  prop="unitName"-->
            <!--  align="center"-->
            <!--  label="公司"-->
            <!--  show-overflow-tooltip-->
            <!--&gt;-->
            <!--</el-table-column>-->
          </el-table>
        </div>
        <!--抽取规则-->
        <div v-if="busProjectObj.busType == '1009007001'" class="zjxq_box">
          <div class="box_text">抽取规则</div>
          <el-table
            class="mt10"
            highlight-current-row
            row-key="id"
            border
            ref="table"
            :data="extractDetailObj"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="80"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="id"
              label="抽取规则ID"
              align="center"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="conditionName"
              label="抽取条件"
              align="center"
              min-width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="speName"
              label="专业"
              align="center"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="persons"
              label="计划抽取人数"
              align="center"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="realNums"
              label="实际抽取人数"
              align="center"
              min-width="180"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="抽取状态"
              align="center"
              min-width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">未抽取</span>
                <span v-if="scope.row.status == 1">抽取中</span>
                <span v-if="scope.row.status == 2">抽取完成</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-row class="zjxq_box">
          <el-col v-if="busProjectObj.busType == '1009007001'" :span="17">
            <span style="color: red">*</span>
            <span>抽取专家方式：</span>
            <span class="zjxq_box_item"
              >{{
                busProjectObj.extractType == 0 ? "手动抽取" : "系统定时抽取"
              }}
              {{ busProjectObj.timingDate }}</span
            >
            <span class="ml20">开标时间：</span>
            <span>{{ rowData.openTime }}</span>
            <span style="color: red"
              >（注：开标前24小时内方可进行专家抽取）</span
            >
          </el-col>
          <el-col :span="6">
            <span style="color: red">*</span>
            <span
              >专家费用支付方式：{{
                busProjectObj.payType == 0 ? "线下支付 " : "线上支付"
              }}</span
            >
          </el-col>
        </el-row>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getExtractDetail } from "../../../../api/modules/projectManagement";

export default {
  name: "expert-needs",
  props: {
    isAudit: {
      default: false
    },
    rowData: {
      type: Object
    }
  },
  data() {
    return {
      activeNames: ["1"],
      evadeUnitsArr: [], // 规避单位
      evadeExpertsArr: [], // 规避专家
      extractDetailObj: [], // 抽取规则
      extractDetailObjList: [],
      busProjectObj: {}
    };
  },
  methods: {
    getExtractDetail() {
      getExtractDetail({
        id: this.rowData.businessId,
        busType: this.busProjectObj.busType
      }).then(res => {
        if (res.operationCode == 1) {
          this.extractDetailObj = res.data.data.extractDetails;
        }
      });
    }
  },
  created() {
    this.evadeUnitsArr = JSON.parse(this.rowData.evadeUnitsArr);
    this.evadeExpertsArr = JSON.parse(this.rowData.evadeExpertsArr);
    this.busProjectObj = JSON.parse(this.rowData.busProjectObj);
    this.busProjectObj.busType == "1009007001" ? this.getExtractDetail() : "";
  }
};
</script>

<style scoped lang="less">
/deep/ .el-collapse-item__header {
  background: #eff6fe;
  font-weight: bolder;
  padding-left: 10px;
}

/deep/ .el-dialog--center .el-dialog__body {
  padding: 15px;
}

/deep/ .el-form-item {
  margin: 0;
}

.zjxq_box {
  padding: 10px 20px;
  margin-bottom: 10px;

  .box_text {
    font-weight: 500;

    &:before {
      content: "";
      width: 3px;
      margin-right: 5px;
      height: 12px;
      background: #1f79ff;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .zjxq_box_item {
    display: inline-block;
    width: 300px;
    height: 40px;
    line-height: 40px;
    background: #f2f2f2;
    padding: 0 5px;
  }

  .box_item {
    width: 100%;
    background: #f8f8f8;
    padding: 15px 25px;
  }
}
</style>
